import {InjectionToken} from "@angular/core";
import {IApplicationsOverviewStateService} from "./i-applications-overview-state.service";

export const applicationsOverviewStateServiceInjectionToken: InjectionToken<IApplicationsOverviewStateService> = new InjectionToken<IApplicationsOverviewStateService>("digital-signage.developer-dashboard.dashboard-web.ApplicationsOverviewStateService");
